<template>
    <div class="searcher-container bg-white flex flex-col px30">
        <div class="cause-search flex items-center">
            <form
                class="input-search-container flex-grow flex"
                @submit="search"
            >
                <input
                    class="w-full"
                    type="text"
                    :placeholder="$t('Search')"
                    v-model="searchValue"
                    @focus="
                        showKeywords = true;
                        showSearchResult = false;
                    "
                />
                <button
                    type="button"
                    class="cause-search-cancel"
                    @click="clearInput"
                >
                    <ClearIcon />
                </button> 
            </form>
            <button
                type="button"
                class="search-btn flex justify-center items-center text-14 text-light_grey"
                @click="cancel"
            >
                {{ $t("Cancel") }}
            </button>
        </div>
        <button
            type="button"
            class="btn-link items-center text-14 text-light_grey mb-6 mx-auto"
            @click="resetSearch"
        >
            {{ $t("Reset search") }}
        </button>
        <ul
            class="recent-keywords"
            v-if="keywords.length > 0 && showKeywords && !showSearchResult"
        >
            <li class="recent-keywords__title flex justify-between mb-5">
                <div class="text-12 font-bold text-light_grey pr-4">
                    {{ $t("Recent Keywords") }}
                </div>
                <button
                    v-ripple
                    type="button"
                    class="recent-keywords__clear btn-link text-12 table text-light_grey"
                    @click="deleteKeywords"
                >
                    {{ $t("Clear All") }}
                </button>
            </li>
            <li
                class="recent-keywords__item flex justify-between mb-8"
                v-for="(item, index) in filterKeywords"
                :key="index"
            >
                <div
                    class="text-14 text-text font-bold cursor-pointer"
                    @click="addToSearchValue(item)"
                >
                    {{ item }}
                </div>
                <button
                    type="button"
                    class="btn-link table "
                    @click="deleteKeyword(item)"
                >
                    <CloseIcon />
                </button>
            </li>
        </ul>
        <div
            v-if="showSearchResult"
            class="flex flex-grow items-center justify-center"
        >
            <div class="text-center text-14 text-light_grey py-4">
                <div class="table mx-auto py-4">
                    <BigSearch />
                </div>

                <p class="mt-6">{{ $t("Sorry") }}</p>
                <p>{{ $t("No Results Found") }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import ClearIcon from "../Icons/ClearIcon";
import CloseIcon from "../Icons/CloseIcon";
import BigSearch from "../Icons/BigSearch";
export default {
    name: "SearchByTitle",
    components: { BigSearch, CloseIcon, ClearIcon },
    props: ["backFunc", "searchTitle", "searchType"],

    data: function() {
        return {
            keywords: [],
            showKeywords: false,
            searchValue: this.searchTitle,
            showSearchResult: false,
            causes: [],
            total: 0,
        };
    },

    mounted() {
        this.getKeywords();
    },

    computed: {
        filterKeywords: function() {
            if (this.searchValue) {
                return this.keywords.filter(item => {
                    return item.indexOf(this.searchValue) !== -1;
                });
            }
            return this.keywords;
        },
    },

    methods: {
        addToSearchValue: function(value) {
            this.searchValue = value;
            this.searchProcess();
        },
        clearInput: function() {
            this.searchValue = ""
        },
        cancel: function () {
            this.searchValue = ""
            this.searchProcess()
        },
        resetSearch: function() {
            this.searchValue = "";
            this.searchProcess();
        },
        search: function(e) {
            e.preventDefault();
            this.searchProcess();
        },
        searchProcess: function() {
            this.showKeywords = false;
            this.searchValue && this.setKeywords(this.searchValue);
            this.$emit("search-by-title", this.searchValue);
            this.backFunc();
        },
        getKeywords: function() {
            let keywordsJson = this.$getLocalStorage("thriveAppKeywords");
            if (keywordsJson) {
                this.keywords = JSON.parse(keywordsJson);
            } else {
                this.keywords = [];
            }

            if (this.keywords.length > 21) {
                this.keywords = this.keywords.slice(0, 20);
                this.updateKeywords();
            }
        },
        setKeywords: function(keyword) {
            if (keyword) {
                let pos = this.keywords.indexOf(keyword);
                if (pos === -1) {
                    this.keywords.push(keyword);
                }
                this.updateKeywords();
            }
        },
        updateKeywords: function() {
            if (this.keywords) {
                this.$setLocalStorage(
                    "thriveAppKeywords",
                    JSON.stringify(this.keywords),
                );
            }
        },
        deleteKeyword: function(keyword) {
            let pos = this.keywords.indexOf(keyword);
            if (pos !== -1) {
                this.keywords.splice(pos, 1);
            }
            this.updateKeywords();
        },
        deleteKeywords: function() {
            this.keywords = [];
            this.updateKeywords();
        },
    },
};
</script>
